import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import { useTickets } from "./TicketContext";
export default function ContactDetails() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    residence: "",
    updates: false,
  });

  const isFormComplete =
    form.firstName &&
    form.lastName &&
    form.email &&
    form.phoneNumber &&
    form.residence;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const navigate = useNavigate();
  const { tickets, setTickets, totalTickets, totalPrice } = useTickets();

  return (
    <>
    <div className="flex flex-col  px-6 md:px-52 bg-[#f8f5eb] ">
    <span className="text-[#003400] text-2xl font-georgia   font-bold">Provide your contact details</span>
    <span className="text-[#003400] text-lg">All fields are mandatory.</span>
    </div>
    <div className="flex flex-col items-center justify-start p-4  pb-12  bg-[#f8f5eb] md:pb-40">

      <div className="grid w-full grid-cols-1 md:grid-cols-2 md:px-44">

      <div className="relative w-full overflow-hidden bg-white rounded-xl">
      <div className="flex flex-col items-center w-full space-y-4">
        <div className="w-full p-4 bg-white rounded-xl">
          <div className="grid grid-cols-1 gap-4 mb-4 md:grid-cols-2">
            <input
              type="text"
              name="firstName"
              placeholder="First name"
              value={form.firstName}
              onChange={handleChange}
              className="w-full p-2.5 border rounded-lg"
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last name"
              value={form.lastName}
              onChange={handleChange}
              className="w-full p-2.5 border rounded-lg"
            />
          </div>
          <input
            type="email"
            name="email"
            placeholder="Email address"
            value={form.email}
            onChange={handleChange}
            className="w-full p-2.5 mb-3 border rounded-lg"
          />
          <div className="mt-5 mb-5">
            <PhoneInput
              country={"sg"}
              value={form.phoneNumber}
              onChange={(phone) => setForm({ ...form, phoneNumber: phone })}
              inputClass="p-2.5 border rounded-lg w-full"
            />
          </div>
          <select
            name="residence"
            value={form.residence}
            onChange={handleChange}
            className="w-full p-6 mb-3 border rounded-lg"
          >
            <option value="">Place of residence</option>
            {[
              "Others", "Italy", "Thailand", "Malaysia", "New Zealand", "France", "China",
              "Middle East",  "Japan", "Taiwan", "Canada", "Europe",
              "United Kingdom", "Australia", "India", "Vietnam", "Korea",
              "Netherlands", "Indonesia", "United States", "Spain", "Philippines",
              "Hong Kong, China"
            ].map((country) => (
              <option key={country} value={country}>{country}</option>
            ))}
          </select>
          <div className="flex items-start mt-5 space-x-2">
            <input
              type="checkbox"
              name="updates"
              checked={form.updates}
              onChange={handleChange}
              className="w-4 h-4 mt-1"
            />
            <span className="text-black text-md font-georgia">
              Yes, I would like to receive updates on events, promotions, and other happenings at Mandai Wildlife Reserve.
            </span>
          </div>
        </div>

        
      </div>
      </div>

       

      <div className="w-full max-w-md p-6 px-12 mt-4 mb-10 bg-white md:ml-5 md:mt-0 h-fit rounded-xl">
        <h2 className="mb-5 text-lg font-bold text-green-900 font-georgia">Total Payable</h2>
        <p className="text-lg font-bold text-gray-900 font-georgia">S${totalPrice}.00</p>
        <p className="text-gray-600 text-md font-georgia">Inclusive of 9% GST S$ 3.55</p>
        <div className="pt-3 mt-3 border-t">
          <h3 className="mt-5 mb-5 text-lg font-bold text-gray-800 font-georgia">Admissions</h3>
          <p className="text-gray-700 text-md font-georgia">Rainforest Wild ASIA Admission</p>
          <div className="flex justify-between mt-2 font-semibold text-md font-georgia">
            <span>Adult (Non-resident)</span>
            <span>x {totalTickets}</span>
            <span>S${totalPrice}.00</span>
          </div>
        </div>
      </div>

      </div>

      <div className="fixed bottom-0 flex justify-end w-full p-4 bg-white">
        <button
          onClick={() => navigate(-1)}
          className="mr-10 text-gray-700 text-md font-georgia hover:underline"
        >
          Back
        </button>
        <button
          onClick={() => navigate("/5")}
          disabled={!isFormComplete}
          className={`px-6 py-2 text-white font-georgia font-bold rounded-full shadow text-md ${
            isFormComplete ? "bg-black" : "bg-gray-400 cursor-not-allowed"
          }`}
        >
          NEXT
        </button>
      </div>

    </div>

    </>

  );
}








